import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * One row of a hairline list (`divide-y` inside one container): a leading tile, the name with a
 * one-line subtitle and optional notes, and trailing controls aligned in one column. The list
 * must be an `@container`: on narrow lists the trailing controls move under the name.
 */
export function ListRow(props: {
  leading: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  /** Extra lines under the subtitle (warnings, hints), each its own element. */
  notes?: ReactNode;
  trailing?: ReactNode;
  className?: string;
}) {
  return (
    <li
      className={cn(
        "grid grid-cols-[auto_minmax(0,1fr)] items-center gap-x-3 gap-y-2 px-3 py-2.5 @lg:grid-cols-[auto_minmax(0,1fr)_auto]",
        props.className,
      )}
    >
      {props.leading}
      <div className="flex min-w-0 flex-col gap-0.5">
        <span className="truncate text-sm text-fg">{props.title}</span>
        {props.subtitle ? (
          <span className="truncate text-xs text-fg-muted tabular-nums">{props.subtitle}</span>
        ) : null}
        {props.notes}
      </div>
      {props.trailing ? (
        <div className="col-start-2 flex items-center gap-1 @lg:col-start-3 @lg:justify-end">
          {props.trailing}
        </div>
      ) : null}
    </li>
  );
}
